<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Upload Product in Bulk</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body wizard-content upload-block">
            <form
              @submit.prevent="() => {}"
              class="tab-wizard wizard-circle wizard clearfix p-1"
            >
              <div class="steps clearfix">
                <ul role="tablist">
                  <li
                    class="first"
                    :class="{current: form.step == 1, done: form.step > 1 }"
                  >
                    <a>
                      <span class="step">1</span>
                      Choose mockup
                    </a>
                  </li>
                  <li
                    :class="{current: form.step == 2, done: form.step > 2 }"
                  >
                    <a>
                      <span class="step">2</span>
                      Information
                    </a>
                  </li>
                  <li
                    class="disabled last"
                    :class="{ current: form.step == 3, done: form.step == 3 && designs.length > 0 }"
                  >
                    <a>
                      <span class="step">3</span>
                      Review Products
                    </a>
                  </li>
                </ul>
              </div>
              <div class="actions mt-2 pr-0 clearfix">
                <ul>
                  <li v-if="form.step > 2">
                    <form-button
                      type="light"
                      :click="previousClicked"
                      :classes="['btn-lg']"
                      text="Previous"
                    />
                  </li>
                  <li v-if="form.step < 3">
                    <form-button
                      :classes="['m-l-10', 'btn-lg', 'btn-custom']"
                      type="default"
                      :click="nextClicked"
                      text="NEXT"
                    />
                  </li>
                  <li
                    v-if="form.step > 2"
                    class="m-l-10"
                  >
                    <form-button
                      :click="uploadProducts"
                      :classes="['btn-lg']"
                      :loading="loading"
                      type="primary"
                      input-type="button"
                      text="UPLOAD PRODUCTS"
                    />
                  </li>
                </ul>
              </div>
              <div v-if="form.step === 1 && mockupOptions.length > 0" class="content clearfix">
                <div class="row">
                  <div class="col-md-12">
                    <alert-box type="danger" v-if="!!error.mockup">
                      {{error.mockup[0]}}
                    </alert-box>
                  </div>
                </div>
                <div class="row" v-if="!storeOptions || storeOptions.length == 0">
                  <div class="col-md-12">
                    <alert-box type="danger" v-if="!!error.mockup">
                      Please create a store to upload new products
                    </alert-box>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-md-12">
                    <input-select
                      @change="getStoreType({ id: form.storeId, dataList: storeList })"
                      name="storeId"
                      label="Store"
                      :value="form.storeId"
                      placeholder="Choose store"
                      :options="storeOptions"
                      :errors="error.storeId"
                      @input="value => { setField({ key: 'storeId', value }) }"
                      :disabled="selectedDefaultStoreId"
                    />
                  </div>
                </div>
                <div class="row" v-if="mockupOptions">
                  <div class="col-md-12">
                    <alert-box class='text-center'>
                      Click <a href="https://printhigh.com/base-cost" target="_blank">HERE</a> to learn more about <a href="https://printhigh.com/base-cost">Shipping Fees</a>
                    </alert-box>
                  </div>
                  <div class="col-md-12">
                    <div class="vtabs">
                      <ul class="nav nav-tabs tabs-vertical" role="tablist">
                        <li
                          class="nav-item"
                          v-for="tab in tabOptions"
                          :key="tab.id"
                        >
                        <span
                          class="nav-link cursor-pointer" :class="{'active': tab.active}"
                          @click="selectTab(tab.id)"
                        >
                          {{tab.text}}
                        </span>
                        </li>
                      </ul>
                      <!-- Tab panes -->
                      <div class="tab-content pr-0 pt-0">
                        <div
                          class="tab-pane"
                          v-for="tab in tabOptions" :class="{'active': tab.active}"
                          :key="tab.id"
                        >
                          <div class="row">
                            <div
                              class="cursor-pointer disable-user-select col-md-4 mb-3 text-center"
                              v-for="option in activeMockupOptions(tab.id)"
                              :key="option.value"
                            >
                              <a style="display:block; border: 1px solid rgba(0, 0, 0, 0.125);   padding: 0.75rem 1.25rem;"
                                  :key="option.value"
                                  :class="{ 'list-group-item-success': option.selected }"
                                  @click="selectMockupAction(option.value)"
                              >
                                <img :src="option.mockup_img" class="mockup-image"/>
                                <div class="pt-2 mt-2 border-top">
                                  <a tabindex="1">
                                    {{option.text}}
                                  </a>
                                </div>
                                <div>
                                  From <b>{{ option.value | displayCatalogPrice(userPrices)}}</b> + Shipping Fee
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="form.step === 2 && mockups.length > 0" class="content clearfix">
                <div class="row pb-3" :class="{ 'has-danger': designError}">
                  <div
                    v-if="mockups.length"
                    :class="designs && designs.length > 0 ? 'col-md-3' : 'col-md-12'"
                  >
                    <div class="dropify-wrapper">
                      <div class="dropify-message">
                        <span class="file-icon"></span>
                        <p>Drag and drop a file here or click</p>
                        <p>Your design should be 4200x4800 for better look and printing</p>
                      </div>
                      <input
                        multiple
                        type="file"
                        accept="image/x-png"
                        ref="fileInput"
                        @change="processFile($event)"
                        @click="$refs.fileInput.value = null"
                      />
                    </div>
                    <small v-if="designError != ''" class="form-control-feedback">
                      {{designError}}
                    </small>
                  </div>
                  <div
                    v-for="design in designs"
                    :key="design.tempId || design.id"
                    class="col-md-3"
                  >
                    <div class="dropify-wrapper has-preview">
                      <div
                        :class="{ 'd-block': design.loading }"
                        class="dropify-loader"
                      ></div>

                      <div
                        :class="{ visible: design.success === false }"
                        class="dropify-errors-container"
                      >
                        <ul>
                          <li>Failed to upload</li>
                        </ul>
                      </div>

                      <button
                        type="button"
                        class="dropify-clear cursor-pointer"
                        @click="() => deleteDesign(design)"
                      >
                        Remove
                      </button>
                      <div class="d-block dropify-preview">
                      <span class="dropify-render">
                        <img
                          :src="design.imageUrl.small"
                          style="max-height: 180px;"
                        />
                      </span>
                        <div class="dropify-infos">
                          <div class="dropify-infos-inner">
                            <p class="dropify-filename">
                              <span class="file-icon"></span>
                              <span class="dropify-filename-inner">{{design.title}}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" v-for="(mockup, index) in mockups" :key="index">
                  <div class="col-md-12">
                    <label>{{mockup.text}}</label></div>
                  <div class="col-md-6">
                    <div class="row justify-content-center">
                      <div class="col-md-12">
                        <img :src="mockup.mockup_img" class="img-thumbnail" v-if="mockup" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <color-picker
                      :options="mockup.colors"
                      :values="form.information && form.information[mockup.value] && form.information[mockup.value].colors ? form.information[mockup.value].colors : form.colors"
                      name="colors"
                      label="Colors"
                      :required="true"
                      :errors="error[`information.${mockup.value}.colors`]"
                      @input="value => setField({ key: `information.${mockup.value}.colors`, value })"
                    />

                    <div v-if="mockup.sizes.length" class="row">
                      <label class="form-label col-md-12">
                        Prices ($)<span class="text-danger">*</span>
                      </label>
                      <div v-for="item in mockup.sizes" class="col-md-6 col-sm-6" :key="item.value">
                        <input-text
                          :inputGroup="true"
                          :name="`${mockup.value}.prices.${item.value}`"
                          :placeholder="item.text"
                          :value="form.information && form.information[mockup.value] && form.information[mockup.value].prices && form.information[mockup.value].prices[item.value]"
                          type="number"
                          :errors="error[`information.${mockup.value}.prices.${item.value}`]"
                          @input="value => setField({ key: `information.${mockup.value}.prices.${item.value}`, value})"
                        >
                          <div class="input-group-prepend" slot="prefix">
                            <span class="input-group-text">{{item.text}}</span>
                          </div>
                        </input-text>
                      </div>
                    </div>

                    <div>
                      <label class="form-label">
                        Keywords
                      </label>
                      <input-text
                        placeholder="Key1, Key2,..."
                        :value="form.information[mockup.value].keywords ? form.information[mockup.value].keywords : ''"
                        @input="value => setField({ key: `information.${mockup.value}.keywords`, value})"
                      >
                      </input-text>
                    </div>
                  </div>
                  <div class="col-md-12"><hr></div>
                </div>
                <!--Description-->
                <div class="row">
                    <div class="col-md-12">
                      <text-area
                        :value="form.description"
                        name="description"
                        label="Description"
                        placeholder="Description"
                        :required="false"
                        @input="value => setField({ key: 'description', value })"
                      />
                    </div>
                  </div>
              </div>
              <div v-if="form.step === 3" class="content clearfix">
                <div class="col-sm-12">
                    <div class="card">
                      <div class="table-responsive">
                        <table
                          class="table table-striped dataTable no-footer"
                          style="width: 100%;"
                        >
                          <thead>
                          <tr>
                            <th>Image</th>
                            <th>Title</th>
                            <th>Mockup</th>
                            <th>Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr
                            v-for="(design, index) in designProducts"
                            :key="index"
                            :class="index % 2 == 0 ? 'odd' : 'even'"
                          >
                            <td>
                              <img
                                :src="design.imageUrl.small"
                                :alt="design.title" width="60"
                                :class="$options.filters.backgroundColor(design.colors[0])"
                              />
                            </td>
                            <td>
                              <b>{{ design.title }}</b>
                            </td>
                            <td>
                              <b>{{ mockupName[design.catalogId] }}</b>
                            </td>
                            <td>
                              <div>
                                <button type="button" @click="openDesignForm({catalogId: design.catalogId, designId: design.id})" class="btn btn-secondary"><i class="ti-pencil" aria-hidden="true"></i></button>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="actions mt-2 pr-0 clearfix">
                <ul>
                  <li v-if="form.step > 2">
                    <form-button
                      type="light"
                      :click="previousClicked"
                      :classes="['btn-lg']"
                      text="Previous"
                    />
                  </li>
                  <li v-if="form.step < 3">
                    <form-button
                      :classes="['m-l-10', 'btn-lg', 'btn-custom']"
                      type="default"
                      :click="nextClicked"
                      text="NEXT"
                    />
                  </li>
                  <li
                    v-if="form.step > 2"
                    class="m-l-10"
                  >
                    <form-button
                      :click="uploadProducts"
                      :classes="['btn-lg']"
                      :loading="loading"
                      type="primary"
                      input-type="button"
                      text="UPLOAD PRODUCTS"
                    />
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show="form.showStoreMode"
      title="Confirm"
      :close="() => setField({ key: 'showStoreMode', value: false })"
    >
      <div class="card-body">
        <alert-box type="danger" v-if="modeError">
          {{modeError}}
        </alert-box>
        <form @submit.prevent="() => {}">
          <div class="row justify-content-md-end">
            <div class="col-md-12">
              <input-select
                name="mode"
                label="Store mode"
                :value="form.mode"
                placeholder="Choose mode"
                :options="modeOptions"
                @input="value => { setField({ key: 'mode', value }) }"
              />
            </div>
          </div>
        </form>
      </div>
      <div slot="footer">
        <div slot="footer">
          <div class="flex-group">
            <form-button
              type="primary"
              class="mr-2"
              :loading="form.loading"
              :click="confirmModeToCreateProduct"
              text="Confirm"
            />
            <button type="button" class="btn btn-secondary flex-item" @click="() => setField({ key: 'showStoreMode', value: false })">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </modal>
    <upload-modal
      :showUpModal="designFormShow"
      :loadingData="loadingModal"
      :multipleRow="false"
      :closeUpModal="closeDesignForm"
      titleUpModal="Edit Design Information"
      :designForm="this.designForm"
      :designFormError="this.designFormError"
      :editOptions="this.editOptions"
      :closeDesignForm="this.closeDesignForm"
      :saveDesignForm="this.saveDesignForm"
      :setDesignFormField="this.setDesignFormField"
    >
    </upload-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import InputText from "@/components/Form/InputText";
import FormButton from "@/components/Form/FormButton";
import InputSelect from "@/components/Form/InputSelect";
import AlertBox from "@/components/Misc/AlertBox";
import LinkButton from "@/components/Misc/LinkButton";
import TextArea from "@/components/Form/TextArea";
import ColorPicker from "@/components/Form/ColorPicker";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import UploadModal from "@/components/Common/UploadModal";
import Breadcrumb from "@/components/Common/Breadcrumb";
import Modal from "@/components/Misc/Modal";

export default {
  name: "UploadForm",
  components: {
    InputText,
    InputSelect,
    FormButton,
    AlertBox,
    LoadingContainer,
    LinkButton,
    TextArea,
    ColorPicker,
    UploadModal,
    Breadcrumb,
    Modal
  },
  async beforeMount() {
    const query = this.$route.query;
    await this.getConfiguration();

    if (query.storeId) {
      const storeId = parseInt(query.storeId);
      const store = this.storeList.find(item => item.id === storeId);
      if (store) {
        this.setField({ key: 'storeId', value: storeId });
      }
    }
  },
  computed: {
    ...mapGetters({
      storeList: "store/list",
      mockupOptions: "upload/mockupOptions",
      mockupName: "upload/mockupName",
      settings: "upload/settings",
      designs: "upload/designs",
      designProducts: "upload/designProducts",
      form: "upload/form",
      tabOptions: "upload/tabOptions",
      designForm: "upload/designForm",
      designFormShow: "upload/designFormShow",
      designFormError: "upload/designFormError",
      loading: "upload/loading",
      loadingModal: "product/loadingModal",
      designError: "upload/designError",
      modeError: "upload/modeError",
      error: "upload/error",
      priceSetting: "configuration/configs",
      userPrices: "upload/userPrices",
    }),
    mockups() {
      return this.mockupOptions.filter(opt => opt.selected);
    },
    editOptions() {
      let data = [];
      if (this.mockups.length > 0 && this.designForm && this.designForm.catalogId) {
        data = this.mockups.filter( opt => opt.value === this.designForm.catalogId);
        return data[0];
      } else {
        return data;
      }
    },
    currentPage() {
      return this.$store.state.route.meta.title;
    },
    modeOptions() {
      return [
        { value: "combined", text: "All the styles are combined to the same product" },
        { value: "separated", text: "Each style will become a separated product" },
      ];
    },
    storeOptions() {
      const stores = this.storeList
        .map(store => {
          return {
            value: store.id,
            text: store.name
          };
        });

      return stores;
    },
    selectedDefaultStoreId() {
      return this.$route.query.storeId && this.form.storeId;
    },
  },
  created() {
    this.resetForm();
  },
  methods: {
    ...mapActions({
      addDesigns: "upload/addDesigns",
      deleteDesign: "upload/deleteDesign",
      setField: "upload/setField",
      goToStep: "upload/goToStep",
      setDesignFormField: "upload/setDesignFormField",
      openDesignForm: "upload/openDesignForm",
      closeDesignForm: "upload/closeDesignForm",
      saveDesignForm: "upload/saveDesignForm",
      uploadProducts: "upload/uploadProducts",
      resetForm: "upload/resetForm",
      selectMockups: "upload/selectMockups",
      getStoreType: "upload/getStoreType",
      selectTab: "upload/selectTab",
      confirmModeToCreateProduct: "upload/confirmModeToCreateProduct",
      getConfiguration: "configuration/getConfiguration",
    }),
    activeMockupOptions(type) {
      return this.mockupOptions && this.mockupOptions.filter(opt => opt.category == type);
    },
    selectMockupAction(option) {
      this.selectMockups({ mockupId: option, priceSetting: this.priceSetting });
    },
    previousClicked() {
      if (this.form.step > 1) {
        this.goToStep(this.form.step - 1);
      }
    },
    nextClicked() {
      if (this.form.step < this.form.totalSteps) {
        this.goToStep(this.form.step + 1);
      }
    },
    async processFile(event) {
      const uploadFiles = event.target.files;
      await this.addDesigns({ files: [...uploadFiles] });
    },
  },
  filters: {
    displayCatalogPrice(value, userPrices) {
      const price = userPrices.find(item => item.id == value);
      if (price) {
        return `$${_.get(price, 'sizeCost.base')}`;
      }

      return 'N/A';
    }
  }
};
</script>
<style>
@import "../../assets/libs/wizard/steps.css";
@import "../../assets/libs/dropify/dist/css/dropify.css";
</style>
<style scoped>
  .dropify-wrapper .dropify-preview,
  .dropify-wrapper .dropify-preview .dropify-render img {
    background-color: #ccc !important;
  }

  .list-group-item {
    cursor: pointer;
  }

  .list-group-item:hover {
    background: #b8e7fc;
  }

  .mockup-image {
    max-width: 190px;
    width: 100%;
  }

  .upload-block.wizard-content .wizard>.steps>ul>li.current:not(.done) .step {
    color: #01c0c8;
    border-color: #01c0c8;
  }

  .upload-block.wizard-content .wizard.wizard-circle>.steps>ul>li.done:after,
  .upload-block.wizard-content .wizard.wizard-circle>.steps>ul>li.done:before,
  .upload-block.wizard-content .wizard.wizard-circle>.steps>ul>li.current:before {
    background-color: #01c0c8;
  }

  .upload-block.wizard-content .wizard>.steps>ul>li.done .step {
    background-color: #01c0c8;
    border-color: #01c0c8;
  }

  .btn-custom {
    color: #fff;
    border-color: #01c0c8;
    background-color: #01c0c8;
  }
</style>
